import React from 'react';
import { AppContext } from '../../context/AppContext';
import FormCompany from '../../components/FormCompany/FormCompany';

const CreateCompanyForAdmin = () => {
    const { createCompany } = React.useContext(AppContext);

    return (
        <FormCompany 
            mode="create"
            pageTitle="Agregar Empresa"
            breadcrumbTitle="Agregar Empresa"
            onSubmitFunc={createCompany}
        />
    );
};

export default CreateCompanyForAdmin;